import React from "react";
import { Box, Typography, createStyles, withStyles } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import MagicLinkButton from "./MagicLinkButton.web";
import BookCallDialog from "./BookCallDialog.web";
import {
  alignedGutter,
  magicLinkColors,
  magicLinkLayout,
} from "./magicLinkTokens";

interface Props {
  logo?: string | null;
  firmName?: string | null;
  helpHref?: string | null;
  meetingLink?: string | null;
  classes: Record<string, string>;
}

interface State {
  bookCallOpen: boolean;
}

const styles = (theme: any) =>
  createStyles({
    header: {
      position: "sticky",
      top: 0,
      zIndex: theme.zIndex.appBar,
      height: magicLinkLayout.headerHeight,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      padding: `12px ${alignedGutter(24)}`,
      backgroundColor: magicLinkColors.surface,
      borderBottom: `1px solid ${magicLinkColors.border}`,
      [theme.breakpoints.down("xs")]: {
        padding: `12px ${alignedGutter(16)}`,
      },
    },
    logo: {
      maxHeight: 40,
      maxWidth: 128,
      objectFit: "contain"
    },
    firmName: {
      fontFamily: "Nunito Sans",
      fontSize: "18px",
      fontWeight: 600,
      color: theme.palette.primary.main
    },
    actions: {
      display: "flex",
      alignItems: "center",
      gap: 8
    },
    helpIcon: {
      fontSize: "16px !important"
    },
    helpButton: {
      [theme.breakpoints.down("xs")]: {
        display: "none"
      }
    }
  });

class MagicLinkHeader extends React.Component<Props, State> {
  state: State = { bookCallOpen: false };

  openHelp = () => {
    if (this.props.helpHref) {
      window.open(this.props.helpHref, "_blank", "noopener");
    }
  };

  render() {
    const { logo, firmName, helpHref, meetingLink, classes } = this.props;
    return (
      <Box component="header" className={classes.header}>
        <Box>
          {logo ? (
            <img src={logo} alt={firmName || "logo"} className={classes.logo} />
          ) : (
            <Typography className={classes.firmName}>{firmName}</Typography>
          )}
        </Box>
        <Box className={classes.actions}>
          {helpHref && (
            <MagicLinkButton
              variant="outline"
              onClick={this.openHelp}
              className={classes.helpButton}
              startIcon={<HelpOutlineIcon className={classes.helpIcon} />}
            >
              Need help? Contact us
            </MagicLinkButton>
          )}
          {meetingLink && (
            <MagicLinkButton
              onClick={() => this.setState({ bookCallOpen: true })}
            >
              Book a call
            </MagicLinkButton>
          )}
        </Box>
        {meetingLink && (
          <BookCallDialog
            open={this.state.bookCallOpen}
            meetingLink={meetingLink}
            onClose={() => this.setState({ bookCallOpen: false })}
          />
        )}
      </Box>
    );
  }
}

export default withStyles(styles)(MagicLinkHeader);
